(() => {
  if (customElements.get('mini-faq-item')) return;

  const DropdownItemElement = customElements.get('dropdown-item');
  if (!DropdownItemElement) return;

  class MiniFaqItem extends DropdownItemElement {
    show() {
      super.show();
      this.header.setAttribute('aria-expanded', 'true');
    }

    hide() {
      super.hide();
      this.header.setAttribute('aria-expanded', 'false');
    }

    // The base component closes every dropdown on the page; keep it within this list.
    deactivateAll() {
      const group = this.closest('[data-mini-faq-group]');
      if (!group) return;

      group.querySelectorAll('mini-faq-item').forEach((item) => {
        if (item === this) return;
        if (!item.parent.classList.contains('active')) return;

        item.hide();
      });
    }
  }

  customElements.define('mini-faq-item', MiniFaqItem);
})();
